import _ from 'underscore';
import _VMFactory from './../_VMFactory';
/**
 * Add an aspect property to create recreate the view model object from data
 * Private aspect used by flow to recreate a view model object from a snapshot
 **/
export default {
    'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode, ancestorChain) {
        if (ancestorChain.parent) {
            // only interested in root objects
            return undefined;
        }
        return {
            _vmFromData: {
                'get': function get() {
                    return _.partial(_VMFactory(currentViewModelNode._aspectFactories).create, _, currentMetadataNode);
                }
            }
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-viewmodel-js/aspects/RebuildVMFromData.js
// module id = 1384
// module chunks = 0